import { render, staticRenderFns } from "./GainLossReports.vue?vue&type=template&id=0c3d0a4f&scoped=true&"
import script from "./GainLossReports.vue?vue&type=script&lang=js&"
export * from "./GainLossReports.vue?vue&type=script&lang=js&"
import style0 from "./GainLossReports.vue?vue&type=style&index=0&id=0c3d0a4f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c3d0a4f",
  null
  
)

export default component.exports